/**
 * PkKlaerenDialog - record «Abweichung geklaert» and release the closure (P2 Slice 15, Tab 6, E8).
 */
import { useState } from 'react';
import { PK_KLAERUNG_BESTAETIGUNG } from '@brokly/shared';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';

export function PkKlaerenDialog({
  open,
  onClose,
  onKlaeren,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  onKlaeren: (grund: string) => void;
  saving: boolean;
  error: { code?: string } | null;
}) {
  const [grund, setGrund] = useState('');
  const errorText = error?.code ? 'Klaerung fehlgeschlagen' : null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Abweichung geklaert"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Abbrechen</Button>
          <Button disabled={saving || grund.trim().length < 3} onClick={() => onKlaeren(grund.trim())} data-testid="pk-klaeren-submit">
            Abweichung geklaert
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm" data-testid="pk-klaeren-dialog">
        <p className="text-xs text-muted-foreground">{PK_KLAERUNG_BESTAETIGUNG}</p>
        <label className="block">
          <span className="text-xs text-muted-foreground">Grund / Ergebnis der Klaerung</span>
          <textarea value={grund} onChange={(e) => setGrund(e.target.value)} rows={3} maxLength={2000} className="mt-1 w-full rounded-md border border-border p-2" data-testid="pk-klaeren-grund" />
        </label>
        {errorText && <p className="text-sm text-status-danger" data-testid="pk-klaeren-error">{errorText}</p>}
      </div>
    </Dialog>
  );
}
